import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMundialGroups } from './../../redux/actions/groups.actions';
import { usePrivateRoute } from './../../hooks/usePrivateRoute';
//-----------------------------------------------------------------------
import { MundialGroup } from './components/MundialGroup';

export const GroupsView = () => {
  usePrivateRoute();
  const { standings } = useSelector(state => state.Mundial.Groups);
  const dispatch = useDispatch();

  useEffect(() => {
    if (standings.length > 0) return;
    dispatch(getMundialGroups());
  }, []);

  return (
    <div className="groups-view">
      {standings?.map(({ participants, phase }) => (
        <MundialGroup
          key={phase.id}
          teams={participants}
          groupName={phase.names.default}
        />
      ))}
    </div>
  );
};
